export default {
  title: "Facturen overzicht",
  noRecords: "Geen facturen gevonden",
}
